'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import MinimizedBetaButton from './MinimizedBetaButton';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const OptMinimized = ({
  onMaximized
}) => {
  return /*#__PURE__*/_jsx(MinimizedBetaButton, {
    icon: "none",
    onClick: onMaximized,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-addon-opt.beta"
    })
  });
};
OptMinimized.propTypes = {
  onMaximized: PropTypes.func.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
OptMinimized.defaultProps = {
  onMaximized: emptyFunction
};
export default OptMinimized;